import PropTypes from 'prop-types';

export const VotedUsersProps = {
  siteMembers: PropTypes.array,
  option: PropTypes.object,
  showVoters: PropTypes.bool,
  showVotes: PropTypes.bool,
};
